import React from 'react';
import { Hourglass } from 'react-loader-spinner';

const HourLoading = () => {
  return (
    <div className="flex justify-center">
      <div className="p-4 rounded-xl bg-gradient-to-br from-yellow-300/10 to-green-400/20 shadow-lg hover:shadow-xl transition-shadow duration-300 animate-pulse flex flex-col items-center">
        <Hourglass
          visible={true}
          height="60"
          width="60"
          ariaLabel="hourglass-loading"
          wrapperStyle={{}}
          wrapperClass=""
          colors={['#ca8a04', '#16a34a']}
        />
        <p className="mt-2 text-green-500 text-sm font-medium">Chargement...</p>
      </div>
    </div>
  );
};

export default HourLoading;